import { inject, Pipe, PipeTransform } from "@angular/core";
import { dateUtil } from "src/app/support/date-util";
import { RegionService } from "src/app/services/feature-access-control/region.service";

@Pipe({
  name: "dateDiff",
  standalone: false
})
export class DateDiffPipe implements PipeTransform {
  private readonly regionService = inject(RegionService);

  transform(
    value: string,
    fromDate: string,
    unit: "seconds" | "days" | "months" = "days"
  ): number {
    return dateUtil(value)
      .locale(this.regionService.getLocale())
      .diff(fromDate, unit);
  }
}
